import React from 'react';
import {
  UtilityBar,
  UtilityBarButton as UBButton,
} from '@mummssoftware/common-ui';
import { FormattedMessage } from 'react-intl';
import { messages } from '../Medication/messages';

export const ListingToolbar = React.memo(
  ({
    resetFilters,
    expandAll,
    collapseAll,
    showAll,
    showActive,
    showRecent,
    showNeedsApproval,
    readOnly,
  }) => (
    <UtilityBar>
      {readOnly ? null : (
        <UBButton onClick={resetFilters}>
          <FormattedMessage {...messages.reset} />
        </UBButton>
      )}
      <UBButton onClick={expandAll}>
        <FormattedMessage {...messages.expand} />
      </UBButton>
      <UBButton onClick={collapseAll}>
        <FormattedMessage {...messages.collapse} />
      </UBButton>
      <UBButton onClick={showActive}>
        <FormattedMessage {...messages.showActive} />
      </UBButton>
      <UBButton onClick={showRecent}>
        <FormattedMessage {...messages.showRecent} />
      </UBButton>
      <UBButton onClick={showNeedsApproval}>
        <FormattedMessage {...messages.showNeedsApproval} />
      </UBButton>
      <UBButton onClick={showAll}>
        <FormattedMessage {...messages.showAll} />
      </UBButton>
    </UtilityBar>
  ),
);
